import { render, staticRenderFns } from "./footnote.vue?vue&type=template&id=34d2f4f0&scoped=true&"
import script from "./footnote.vue?vue&type=script&lang=js&"
export * from "./footnote.vue?vue&type=script&lang=js&"
import style0 from "./footnote.vue?vue&type=style&index=0&id=34d2f4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d2f4f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
